import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    vux: {
      isLoading: false
    },
    point: {
      lng: 113.878474,
      lat: 22.575949
    }, // 当前坐标
    currentCity: {}, // 当前城市
    isShare: false, // jssdk是否准备好
    moreClassifyIndex: 0,
    businessClassifyIndex: 0
  },
  mutations: {
    updateLoadingStatus (state, payload) {
      state.vux.isLoading = payload.isLoading
    },
    updatePoint (state, point) {
      if (point.lng) state.point = point
    },
    updateCurrentCity (state, data) {
      state.currentCity = data
    },
    updateIsShare (state, data) {
      state.isShare = data
    },
    updateMoreClassifyIndex (state, data) {
      state.moreClassifyIndex = data
    },
    updateBusinessClassifyIndex (state, data) {
      state.businessClassifyIndex = data
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/stores/index.js